import { Box, Flex, Text, Badge } from '@chakra-ui/react';

interface Props {
  viewLabel: string;
}

export function AnalyticsHeader({ viewLabel }: Props) {
  return (
    <Flex justify="space-between" align="center" mb="20px">
      <Box>
        <Text fontSize="2xl" fontWeight="700" color="gray.800">
          Sales Analytics
        </Text>
        <Flex align="center" gap="8px" mt="4px">
          <Text fontSize="sm" color="gray.500">
            Viewing:
          </Text>
          <Badge
            colorScheme="brand"
            fontSize="xs"
            px="8px"
            py="2px"
            borderRadius="6px"
          >
            {viewLabel}
          </Badge>
        </Flex>
      </Box>
    </Flex>
  );
}
